import React, { useState, useEffect } from 'react';
import { isOnClient } from '@growth/ssr-utils';
import { useAnalytics, AnalyticsContextProvider } from '@growth/use-analytics';
import { s as sendPdtEvent, i as initOmnitureAnalytics } from './omniture-4e08e7dc.esm.js';
import { G as GoTribeWidgetContent } from './GoTribeWidgetContent-199506be.esm.js';

var GoTribeReviewInner = function GoTribeReviewInner(_ref) {
  var header = _ref.header,
    subHeader = _ref.subHeader,
    imageUrl = _ref.imageUrl,
    benefits = _ref.benefits,
    lob = _ref.lob,
    tier = _ref.tier,
    isMobile = _ref.isMobile,
    cardId = _ref.cardId,
    onLoad = _ref.onLoad,
    wrapperStyle = _ref.wrapperStyle,
    showBorderedCard = _ref.showBorderedCard;
  var _useAnalytics = useAnalytics(),
    adobe = _useAnalytics.adobe;
  var _useState = useState(false),
    showModal = _useState[0],
    setShowModal = _useState[1];
  var pageName = lob + "_Review_page";
  useEffect(function () {
    adobe.track('ctaClick', {
      cta: {
        name: cardId,
        type: "itemLoaded",
        componentName: cardId
      }
    });
    sendPdtEvent({
      eventName: 'gotribe_lob_inline_review_screenLoad',
      contentId: cardId,
      pageName: pageName
    });
  }, []);
  var handleClick = function handleClick() {
    adobe.track('ctaClick', {
      cta: {
        name: cardId,
        type: "ctaClick",
        componentName: cardId
      }
    });
    sendPdtEvent({
      eventName: 'gotribe_lob_inline_review_ctaClick',
      contentId: cardId,
      pageName: pageName
    });
    setShowModal(true);
  };
  var onCloseModal = function onCloseModal(cta) {
    adobe.track('ctaClick', {
      cta: {
        name: "cross_click",
        type: "ctaClick  | " + cta + " | " + lob + "_Review",
        componentName: 'GI_GOTRIBE_LOB_BOTTOMSHEET_PROG_DETAIL'
      }
    });
    sendPdtEvent({
      eventName: "gotribe_lob_bottomsheet_prog_detail_Click | " + cta,
      contentId: 'GI_GOTRIBE_LOB_BOTTOMSHEET_PROG_DETAIL',
      pageName: pageName
    });
    setShowModal(false);
  };
  var onModalLoad = function onModalLoad() {
    adobe.track('ctaClick', {
      cta: {
        name: 'GI_GOTRIBE_LOB_BOTTOMSHEET_PROG_DETAIL',
        type: "itemLoaded | " + lob + "_Review",
        componentName: 'GI_GOTRIBE_LOB_BOTTOMSHEET_PROG_DETAIL'
      }
    });
    sendPdtEvent({
      eventName: 'gotribe_lob_bottomsheet_prog_detail_screenLoad',
      contentId: 'GI_GOTRIBE_LOB_BOTTOMSHEET_PROG_DETAIL',
      contentCategoryName: lob + "_Review",
      pageName: pageName
    });
  };
  return /*#__PURE__*/React.createElement(GoTribeWidgetContent, {
    headerText: header,
    mainDesc: subHeader,
    image: imageUrl,
    benefits: benefits,
    tier: tier,
    lob: lob,
    isMobile: isMobile,
    handleClick: handleClick,
    onCloseModal: onCloseModal,
    onModalLoad: onModalLoad,
    onLoad: onLoad,
    wrapperStyle: wrapperStyle,
    showThankyouPageStyling: !showBorderedCard,
    showModal: showModal
  });
};
GoTribeReviewInner.defaultProps = {
  onLoad: undefined,
  wrapperStyle: undefined,
  showBorderedCard: false
};

var GoTribeReview = function GoTribeReview(_ref) {
  var header = _ref.header,
    subHeader = _ref.subHeader,
    imageUrl = _ref.imageUrl,
    benefits = _ref.benefits,
    lob = _ref.lob,
    tier = _ref.tier,
    isMobile = _ref.isMobile,
    cardId = _ref.cardId,
    onLoad = _ref.onLoad,
    wrapperStyle = _ref.wrapperStyle,
    showBorderedCard = _ref.showBorderedCard;
  var adobe;
  if (isOnClient) {
    adobe = initOmnitureAnalytics({
      lobName: lob,
      debug: false,
      flavour: isMobile ? 'mweb' : 'dweb'
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnalyticsContextProvider, {
    adobeInstance: adobe
  }, /*#__PURE__*/React.createElement(GoTribeReviewInner, {
    header: header,
    subHeader: subHeader,
    imageUrl: imageUrl,
    benefits: benefits,
    lob: lob,
    tier: tier,
    isMobile: isMobile,
    cardId: cardId,
    onLoad: onLoad,
    wrapperStyle: wrapperStyle,
    showBorderedCard: showBorderedCard
  })));
};
GoTribeReview.defaultProps = {
  onLoad: undefined,
  wrapperStyle: undefined,
  showBorderedCard: false
};

export { GoTribeReview as G };
